import { LOCAL_STORAGE_KEY_BRANCH } from '@/constants/localStorageKeys'

const branchRegex = /branches\/([a-z A-Z 0-9 -]+)/
export const getBranchFromPathUrl = () => {
  const currentUrl = window.location.pathname
  const getNamespace = currentUrl.match(branchRegex) || []
  return getNamespace[1] || ''
}

export const getOriginUrlWithoutBranch = (path: string) => {
  const splited = path.split('/')
  const take = splited.slice(3, splited.length)
  return `/${take.join('/')}`
}

export const createRouteForLink = (path: string, branch?: string) => {
  const currentUrl = window.location.pathname
  const getBranch =
    currentUrl.match(branchRegex) ||
    (getBranchLocalStorage()
      ? [`branches/${getBranchLocalStorage()}`, getBranchLocalStorage()]
      : '')
  if (branch) {
    return path.replace(':branch', branch)
  }

  /**
   * Create Fallback while accessing new route with URL from old URL
   */
  const selectedBranch = ''
  const fallbackNamespace = selectedBranch
    ? `/branches/${selectedBranch}${path}`
    : `/branches?redirect=${path}`
  const isFullPath = path.includes('/branches/:branch')
  if (isFullPath && getBranch) {
    return path.replace(':branch', getBranch[1])
  }
  return getBranch ? `/${getBranch[0]}${path}` : fallbackNamespace
}

export const createRouteForPath = (path: string) => {
  const routeWithBranch = '/branches/:branch'
  return `${routeWithBranch}${path}`
}

export const createRouteForAPI = (
  path: string,
  data: { [key: string]: string | number | undefined },
) => {
  let result = path
  for (const prop in data) {
    const element = data[prop]
    if (element !== undefined) {
      result = result.replace(`:${prop}`, String(element))
    }
  }

  return result
}

export const saveBranch = (branch: string) => {
  window.localStorage.setItem(LOCAL_STORAGE_KEY_BRANCH, branch)
}
export const removeBranch = () => {
  window.localStorage.removeItem(LOCAL_STORAGE_KEY_BRANCH)
}

export const getBranchLocalStorage = () => {
  return window.localStorage.getItem(LOCAL_STORAGE_KEY_BRANCH) as string
}
